import React from "react";

const AdminFooter = () => {
  return (
    <div className="w-full h-1/6 bg-green-500 absolute bottom-0">
      <audio>
        <source src=""></source>
      </audio>
    </div>
  );
};

export default AdminFooter;
